export type CompareCheckboxActionIndex = 'added' | 'removed' | 'isFull';
export enum CompareCheckboxAction {
  Added = 'added',
  Removed = 'removed',
  IsFull = 'isFull',
}
